<style scoped lang="less">
.chart-container {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    width: 100%;
    display: flex;
    .chart1 {
        width: 100%;
        height: 500px;
    }
    .chart2-container {
        margin-top: 90px;
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: space-around;
        .chart2 {
            width: 45%;
            height: 100%;
        }
    }
}
</style>

<template>
    <div class="yb-container">
        <div class="line-container">
            <el-radio-group v-model="dimension" size="mini" @change="getChart">
                <el-radio-button label="day">天维度</el-radio-button>
                <el-radio-button label="week">周维度</el-radio-button>
                <el-radio-button label="month">月维度</el-radio-button>
            </el-radio-group>
            <el-date-picker class="margin-l" size="mini" style="width: 250px;" v-model="date" type="daterange"
                range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" :picker-options="pickerOptions"
                @change="getChart"></el-date-picker>
            <el-button size="mini" class="margin-l" type="primary" @click.stop="getChart"
                :loading="loading">搜索</el-button>
        </div>
        <div class="chart-container">
            <div id="chart1" class="chart1"></div>
            <div class="chart2-container">
                <div id="chart21" class="chart2"></div>
                <div id="chart22" class="chart2"></div>
            </div>
        </div>
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable";
import { HttpClient } from "../util/http.js";

import { removeModel } from "../util/restful.js";
import { actionConfirm, msgSuccess } from "../util/toast.js";
import * as xlsx from "xlsx";
import { exportExcel } from "../util/exportExcel.js";
import dayjs from "dayjs";
import { loginState } from "../util/login.js";
import * as echarts from "echarts";

export default {
    components: {
        PagedTable,
    },
    mixins: [],
    data() {
        return {
            loading: false,
            chart1: null,
            chart21: null,
            chart22: null,
            data: [],
            dimension: "week",
            //最近一年
            date: [dayjs().subtract(1, "year"), dayjs()],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '全部',
                        onClick(picker) {
                            picker.$emit('pick', [,]);
                        }
                    },
                    {
                        text: '今天',
                        onClick(picker) {
                            const start = dayjs().startOf('day').toDate();
                            const end = dayjs().endOf('day').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '当周',
                        onClick(picker) {
                            const start = dayjs().startOf('week').toDate();
                            const end = dayjs().endOf('week').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '当月',
                        onClick(picker) {
                            const start = dayjs().startOf('month').toDate();
                            const end = dayjs().endOf('month').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '上周',
                        onClick(picker) {
                            const start = dayjs().subtract(1, 'week').startOf('week').toDate();
                            const end = dayjs().subtract(1, 'week').endOf('week').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '上月',
                        onClick(picker) {
                            const start = dayjs().subtract(1, 'month').startOf('month').toDate();
                            const end = dayjs().subtract(1, 'month').endOf('month').toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const start = dayjs().subtract(1, 'week').startOf('day').toDate();
                            const end = dayjs().toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const start = dayjs().subtract(1, 'month').startOf('day').toDate();
                            const end = dayjs().toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const start = dayjs().subtract(6, 'month').startOf('day').toDate();
                            const end = dayjs().toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const start = dayjs().subtract(1, 'year').startOf('day').toDate();
                            const end = dayjs().toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    },
                ]
            },
        };
    },
    created() {
        this.getChart();
    },
    computed: {
    },
    mounted() { },
    methods: {
        async getChart() {
            let cond = {
                dimension: this.dimension,
            }
            if (this.date && this.date.length && this.date.length == 2) {
                cond["start"] = dayjs(this.date[0]).format("YYYY-MM-DD");
                cond["end"] = dayjs(this.date[1]).format("YYYY-MM-DD");
            }
            this.loading = true;
            let res = await HttpClient.post("/value/chart", cond);
            this.loading = false;
            this.data = res
            this.$nextTick(() => {
                this.draw1();
                this.draw2();
            });
        },
        draw1() {
            if (!this.chart1) {
                this.chart1 = echarts.init(document.getElementById("chart1"));
            }
            let data = this.data.chart1;
            let emphasisStyle = {
                itemStyle: {
                    shadowBlur: 10,
                    shadowColor: 'rgba(0,0,0,0.3)'
                }
            };
            let option = {
                title: {
                    text: `会员消费与充值统计`,
                    left: "center",
                },
                grid: {
                    left: 65,
                    right: 15,
                    top: 80,
                    bottom: 40,
                },
                legend: {
                    data: ['消费', '充值'],
                    left: 'center',
                    top: 30,
                },
                tooltip: {},
                xAxis: {
                    type: 'category',
                    data: data.map(item => item.date),
                    axisLabel: {
                        margin: 20,          // 横坐标标签与轴线距离（默认8，调大后离柱子更远）
                    },
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        margin: 15,          // 纵坐标标签与轴线距离（默认8，调大后离柱子更远）
                    },
                },
                series: [
                    {
                        name: '消费',
                        type: 'bar',
                        stack: 'one',
                        emphasis: emphasisStyle,
                        label: {  // 设置标签
                            show: true,  // 显示标签
                            fontSize: 12,  // 字体大小
                            position: 'bottom',  // 标签位置在柱子内部
                            color: '#000',  // 字体颜色白色
                            formatter: function (params) {
                                return Math.round(params.value).toLocaleString()
                            }, // 显示数据值
                        },
                        data: data.map(item => item.consume),
                    },
                    {
                        name: '充值',
                        type: 'bar',
                        stack: 'one',
                        emphasis: emphasisStyle,
                        label: {  // 设置标签
                            show: true,  // 显示标签
                            fontSize: 12,  // 字体大小
                            position: 'top',  // 标签位置在柱子内部
                            color: '#000',  // 字体颜色白色
                            formatter: function (params) {
                                return Math.round(params.value).toLocaleString()
                            }, // 显示数据值
                        },
                        data: data.map(item => item.charge),
                    },
                ]
            };
            this.chart1.setOption(option);
        },
        draw2() {
            if (!this.chart21) {
                this.chart21 = echarts.init(document.getElementById("chart21"));
            }
            if (!this.chart22) {
                this.chart22 = echarts.init(document.getElementById("chart22"));
            }
            let data21 = this.data.chart21;
            let data22 = this.data.chart22;
            let option21 = {
                title: {
                    text: '充值金额占比',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b} {c}条 ({d}%)'
                    // {a} 系列名称
                    // {b} 数据项名称
                    // {c} 数值
                    // {d} 百分比
                },
                legend: {
                    orient: 'vertical',
                    left: 'left'
                },
                series: [
                    {
                        type: 'pie',
                        radius: '70%',
                        data: data21,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        label: {
                            show: true,
                            formatter: '{b} {d}%' // {b}表示名称，{d}表示百分比
                        }
                    }
                ]
            };
            let option22 = {
                ...option21,
                title: {
                    text: '消费金额占比',
                    left: 'center'
                },
                series: [
                    {
                        type: 'pie',
                        radius: '70%',
                        data: data22,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        label: {
                            show: true,
                            formatter: '{b} {d}%' // {b}表示名称，{d}表示百分比
                        }
                    }
                ]
            }
            this.chart21.setOption(option21);
            this.chart22.setOption(option22);
        },
    },
};
</script>
